
			import 'reflect-metadata';
			window["__COMFYUI_FRONTEND_VERSION__"] = __COMFYUI_FRONTEND_VERSION__;
			console.log("ComfyUI Front-end version:", __COMFYUI_FRONTEND_VERSION__);
		